import { Injectable, TemplateRef } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ToastService {
  toasts: any[] = [];

  show(textOrTpl: string | TemplateRef<any>, options: any = {}) {
    this.toasts.push({ textOrTpl, ...options });
  }

  showError(textOrTpl: string | TemplateRef<any>, options: any = {}) {
    const defaultOptions = {classname: 'toast-error'};
    options = {...defaultOptions, ...options};
    this.show(textOrTpl, options);
  }

  showWarning(textOrTpl: string | TemplateRef<any>, options: any = {}) {
    const defaultOptions = {classname: 'toast-warning'};
    options = {...defaultOptions, ...options};
    this.show(textOrTpl, options);
  }

  showSuccess(textOrTpl: string | TemplateRef<any>, options: any = {}) {
    const defaultOptions = {classname: 'toast-success'};
    options = {...defaultOptions, ...options};
    this.show(textOrTpl, options);
  }

  remove(toast) {
    this.toasts = this.toasts.filter(t => t !== toast);
  }
}
